<template>
  <v-card
    :class="classes"
  >
    <v-toolbar
      :color="color"
      :max-height="icon ? 90 : undefined"
      class="text-start elevation-1"
      dark
    >
      <slot
        v-if="$slots.heading"
        name="heading"
      />

      <slot
        v-else-if="$slots.image"
        name="image"
      />

      <div
        v-else-if="title && !icon"
        class="tile-card-heading"
        v-text="title"
      />

      <v-icon
        v-else-if="icon"
        size="32"
        v-text="icon"
      />

      <div
        v-if="text"
        class="headline font-weight-thin"
        v-text="text"
      />
    </v-toolbar>
    <v-row class="mx-3 d-flex">
      <slot />
    </v-row>

    <template v-if="$slots.actions">
      <v-divider
        class="mx-auto"
        style="width:95%"
      />

      <v-card-actions
        class="px-3"
      >
        <slot name="actions" />
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
  export default {
    name: 'MaterialCard',

    props: {
      avatar: {
        type: String,
        default: '',
      },
      color: {
        type: String,
        default: '#6161e2',
      },
      icon: {
        type: String,
        default: undefined,
      },
      image: {
        type: Boolean,
        default: false,
      },
      dialog: {
        type: Boolean,
        default: false,
      },
      text: {
        type: String,
        default: '',
      },
      title: {
        type: String,
        default: '',
      },
    },

    computed: {
      classes () {
        let computedClass = 'rounded-0 mx-2'
        computedClass = this.dialog ? 'mx-auto' : 'rounded-0 mx-2'
        return computedClass
      },
      hasHeading () {
        return Boolean(this.$slots.heading || this.title || this.icon)
      },
      hasAltHeading () {
        return Boolean(this.$slots.heading || (this.title && this.icon))
      },
    },
  }
</script>

<style lang="sass">
</style>
